import BaseService from './BaseService'

class TimezoneService extends BaseService {

  constructor () {
    super({path: 'timezones'})
  }
}

export default new TimezoneService()
